import _ from 'lodash'
import { createSelector } from 'reselect'

const selectProductState = (state) => state.product

export const selectProductsFlatten = createSelector([selectProductState], (productState) => {
  const { listProduct } = productState
  const eventsArray = listProduct?.events || []

  if (!Array.isArray(eventsArray)) return []

  const products = _.flatMap(eventsArray, (event) =>
    (event.products || []).map((product) => ({
      ...product,
      eventId: event.id,
      eventName: event.title,
      eventClosingTime: event.closingTimestamp,
      inStock: (product.maxQuantity || 0) - (product.orderCount || 0),
    })))

  const data = {
    lastProductId: listProduct.lastProductId,
    lastProductTimestamp: listProduct.lastProductTimestamp,
    hasMore: listProduct.hasMore,
    items: products || [],
  }
  return data
})

export const selectSearchResultFlatten = createSelector([selectProductState], (productState) => {
  const searchResult = productState.searchResult || {}
  const eventsArray = searchResult.events || []

  const products = _.flatMap(eventsArray, (event) =>
    (event.products || []).map((product) => ({
      ...product,
      eventId: event.id,
      eventName: event.title,
      eventClosingTime: event.closingTimestamp,
      inStock: (product.maxQuantity || 0) - (product.orderCount || 0),
    })))

  return {
    keyword: searchResult.keyword || '',
    lastProductId: searchResult.lastProductId,
    lastProductTimestamp: searchResult.lastProductTimestamp,
    hasMore: searchResult.hasMore,
    items: products || [],
  }
})
